import { NgModule } from '@angular/core';
import { AppCoreModule } from 'src/app/core/app-core.module';
import { EditProfileModule } from 'src/app/private/edit-profile/edit-profile.module';
import { EditMyProfileRoutingModule } from './edit-my-profile-routing.module';
import { EditMyProfileComponent } from './edit-my-profile.component';

@NgModule({
  declarations: [EditMyProfileComponent],
  exports: [EditMyProfileComponent],
  imports: [AppCoreModule, EditProfileModule, EditMyProfileRoutingModule]
})
export class EditMyProfileModule {}
